"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _FoodMenu = require("./FoodMenu.context");

var _components = require("./components");

var _variants = require("./components/variants");

var FoodMenu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(FoodMenu, _React$Component);

  function FoodMenu() {
    (0, _classCallCheck2["default"])(this, FoodMenu);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FoodMenu).apply(this, arguments));
  }

  (0, _createClass2["default"])(FoodMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          navDisplayVariant = _this$props.navDisplayVariant,
          categoryDisplayVariant = _this$props.categoryDisplayVariant,
          itemDisplayVariant = _this$props.itemDisplayVariant,
          menu = _this$props.menu,
          header = _this$props.header,
          centerHeader = _this$props.centerHeader,
          centerNavigation = _this$props.centerNavigation;
      var variantContext = {
        navDisplay: navDisplayVariant,
        categoryDisplay: categoryDisplayVariant,
        itemDisplay: itemDisplayVariant
      };
      var headerStyle = centerHeader ? {
        textAlign: 'center'
      } : {};
      return _react["default"].createElement(_FoodMenu.VariantProvider, {
        value: (0, _variants.computeVariants)(variantContext)
      }, _react["default"].createElement(_FoodMenu.MenuProvider, {
        value: menu
      }, header && _react["default"].createElement(_semanticUiReact.Header, {
        as: "h1",
        style: headerStyle
      }, header), _react["default"].createElement(_components.MenuNavigation, {
        center: centerNavigation
      })));
    }
  }]);
  return FoodMenu;
}(_react["default"].Component);

exports["default"] = FoodMenu;
;
FoodMenu.propTypes = {
  navDisplayVariant: _propTypes["default"].oneOf(['BasicTabs', 'TabsCategorySidebar']),
  categoryDisplayVariant: _propTypes["default"].oneOf(['VerticalList', 'Column', 'CardRow']),
  itemDisplayVariant: _propTypes["default"].oneOf(['Basic', 'BasicCondensed', 'HorizontalCard', 'VerticalCard']),
  menu: _propTypes["default"].shape({
    schedules: _propTypes["default"].array,
    categories: _propTypes["default"].array,
    items: _propTypes["default"].array,
    modifierSets: _propTypes["default"].array,
    modifiers: _propTypes["default"].array
  }).isRequired,
  header: 'Menu',
  centerHeader: _propTypes["default"].bool,
  centerNavigation: _propTypes["default"].bool
};
FoodMenu.defaultProps = {
  navDisplayVariant: 'BasicTabs',
  categoryDisplayVariant: 'VerticalList',
  itemDisplayVariant: 'Basic',
  header: 'Menu',
  centerHeader: false,
  centerNavigation: false
};